import {NgModule} from '@angular/core';
import {ExtraOptions, RouterModule, Routes} from '@angular/router';
import {AppLayoutComponent} from './layout/app.layout.component';
import {OnboardingComponent} from './components/onboarding/onboarding-layout/onboarding-layout.component';
import {AuthGuard} from './guards/auth.guard';
import {UpgradeComponent} from './components/upgrade/upgrade.component';
import {LoginRedirectGuard} from './guards/login-redirect.guard';

const routerOptions: ExtraOptions = {
    initialNavigation: 'enabledBlocking',
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'top',
    onSameUrlNavigation: 'reload'
};
//TODO create notfound page

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'login' },
    {
        path: '',
        component: AppLayoutComponent,
        children: [
            {
                path: 'dashboard',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'Dashboard',
                },
                loadChildren: () =>
                    import('./components/dashboard/dashboard.module').then(
                        (m) => m.DashboardModule
                    ),
            },
            {
                path: 'member-perks',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'Member Perks',
                },
                loadChildren: () =>
                    import(
                        './components/member-perks/member-perks.module'
                    ).then((m) => m.MemberPerksModule),
            },
            {
                path: 'trips',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'My Trips',
                },
                loadChildren: () =>
                    import('./components/travel/trips/trips.module').then(
                        (m) => m.TripsModule
                    ),
            },
            {
                path: 'experiences',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'Experiences',
                },
                loadChildren: () =>
                    import('./components/experiences/experiences.module').then(
                        (m) => m.ExperiencesModule
                    ),
            },
            {
                path: '',
                children: [
                    {
                        path: 'account',
                        canActivate: [AuthGuard],
                        data: {
                            breadcrumb: 'Account',
                        },
                        loadChildren: () =>
                            import('./components/profile/profile.module').then(
                                (m) => m.ProfileModule
                            ),
                    },
                ],
            },
            {
                path: 'referral',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'Referral',
                },
                loadChildren: () =>
                    import(
                        './components/referral/referral.module'
                    ).then((m) => m.ReferralModule),
            },
            {
                path: 'rewards',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'Rewards',
                },
                loadChildren: () =>
                    import(
                        './components/rewards/rewards.module'
                    ).then((m) => m.RewardsModule),
            },
            {
                path: 'upgrade',
                data: {
                    breadcrumb: 'Upgrade',
                },
                component: UpgradeComponent
            },
            {
                path: 'upgrade/:partnerId',
                data: {
                    breadcrumb: 'Upgrade',
                },
                component: UpgradeComponent
            },


        ],
    },
    {
        path: '',
        component: OnboardingComponent,
        children: [
            {
                path: 'onboarding',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'Onboarding',
                },
                loadChildren: () =>
                    import('./components/onboarding/onboarding.module').then(
                        (m) => m.OnboardingModule
                    ),
            },
        ],
    },
    {
        path: 'signup',
        loadChildren: () =>
            import('./components/signup/signup.module').then(
                (m) => m.SignupModule
            ),
    },
    {
        path: 'login',
        loadChildren: () =>
            import('./components/login/login.module').then(
                (m) => m.LoginModule
            ),
        canActivate: [LoginRedirectGuard]
    },
    {
        path: 'reset',
        loadChildren: () =>
            import('./components/login/login.module').then(
                (m) => m.LoginModule
            ),
    },
    {
        path: 'deals',
        loadChildren: () =>
            import('./components/share-deal/share-deal.module').then(
                (m) => m.ShareDealModule
            )
    },
    {
        path: 'hotels',
        loadChildren: () =>
            import('./components/travel/hotels/hotels.module').then(
                (m) => m.HotelsModule
            ),
    },
    {
        path: '**',
        redirectTo: 'login',
    },
];
@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
